module.exports = __webpack_public_path__ + "img/silver.dbbb6bef.png";